import axios from '@/axios-mock'

const headers = {}

export function searchByKeywords (query, increase = 0) {
  let limit = 20
  let offset = increase * limit
  
  return axios({
    headers,
    url: `/app/search/product?${query}&limit=${limit}&offset=${offset}`
  })
}

export function getHotSearch () {
  return axios({
    headers,
    url: `/app/search/suggest`
  })
  .then(({
    code,
    data
  }) => {
    return Promise.resolve(data)
  })
}

export function getAssociate (keyword) {
  return axios({
    url: `/app/search/associate?keyword=${keyword}`
  })
}



// WEBPACK FOOTER //
// ./static/components/search/apis.js